type AuthSessionResult = {
	data?: {
		user?: unknown;
	} | null;
	error?: unknown;
};

export const missingSessionAfterAuthMessage =
	"Signed in, but your browser did not keep the session. Please enable cookies and try again.";

export const redirectAfterAuthSessionReady = async ({
	targetUrl,
	getSession,
	redirect,
	onMissingSession,
	onError,
}: {
	targetUrl: string;
	getSession: () => Promise<AuthSessionResult>;
	redirect: (url: string) => void;
	onMissingSession: (message: string) => void;
	onError: (error: unknown) => void;
}) => {
	try {
		const { data, error } = await getSession();
		if (error) {
			onError(error);
			return false;
		}

		if (!data?.user) {
			onMissingSession(missingSessionAfterAuthMessage);
			return false;
		}

		redirect(targetUrl);
		return true;
	} catch (error) {
		onError(error);
		return false;
	}
};
